module.exports = __webpack_public_path__ + "media/vendor_management/placeholder_square-7d869ef8.jpg";